import { useNav } from './useNav';

/**
 * Hook para navegación segura con filtros persistidos.
 * Valida que los filtros tengan estructura válida antes de incluirlos en el state de navegación.
 * 
 * @param {Function} getCurrentFilters - Función que retorna los filtros actuales del search ref
 * @returns {Function} Función de navegación que incluye filtros automáticamente si son válidos
 * 
 * @example
 * const navigateWithFilters = useNavigateWithFilters(getCurrentFilters);
 * navigateWithFilters(`/vehiculo/${OPERATION_MODE.VIEW}/${id}`);
 */
export const useNavigateWithFilters = (getCurrentFilters) => {
    const navigate = useNav();
    
    return (url, additionalOptions = {}) => {
        const filters = getCurrentFilters();
        
        const hasValidFilters = filters &&
                               (filters.formValues || filters.selectedValues);
        
        const options = {
            ...additionalOptions,
            state: {
                ...additionalOptions.state,
                ...(hasValidFilters ? { filters } : {})
            }
        };
        
        navigate({ to: url, options });
    };
};
